import { Injectable } from '@angular/core'
import { Observable, fromEvent, merge, of } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class OfflineService {

  obsOnline: Observable<any>
  obsOffline: Observable<any>

  constructor() {
    this.obsOnline = fromEvent(window, 'online')
    this.obsOffline = fromEvent(window, 'offline')
  }

  isOnline() {
    return merge(
      of(null),
      fromEvent(window, 'online'),
      fromEvent(window, 'offline')
    )
      .pipe(map(() => navigator.onLine))
  }

  isOnlinePromise() {
    return new Promise(resolve => {
      if (navigator.onLine) resolve(true)
      let sub = this.obsOnline.subscribe(res => {
        sub.unsubscribe()
        resolve(true)
      })
    })
  }
}
